import { render, staticRenderFns } from "./goods-in-interrogation.vue?vue&type=template&id=671266be"
import script from "./goods-in-interrogation.vue?vue&type=script&lang=js"
export * from "./goods-in-interrogation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports